import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  padding: ${props => props.theme.spacing(10, 5)};
`;

export const StarRating = styled.div`
  margin-bottom: ${props => props.theme.spacing(2)};
  &::before {
    font-size: 1rem;
    letter-spacing: 2px;
    content: '★★★★★';
    background-color: ${props => props.theme.colors.secondary.egg};
    background-clip: text;
    /* stylelint-disable-next-line */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Subheadline = styled.p`
  ${props => props.theme.typography.heading5};
  margin: ${props => props.theme.spacing(2, 0, 7)};
  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(2, 0, 9)};
  }
`;

export const Content = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(8)};
  flex-direction: column;
  @media ${props => props.theme.tablet} {
    flex-direction: row;
    max-width: 990px;
    margin: auto;
  }
`;

export const MealPlanHeadline = styled.h4`
  ${props => props.theme.typography.heading4};
`;

export const RightSideContent = styled.div`
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};

  img {
    max-height: 85px;
    min-width: 85px;
  }
`;

export const MealPlanRow = styled.div`
  display: flex;
  position: relative;
  padding: ${props => props.theme.spacing(3)};
  gap: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.colors.neutral.bone};
  border-radius: 32px;

  img {
    max-height: 85px;
    max-width: 85px;
  }
`;

export const MealPlanBody = styled.div`
  text-align: left;
`;

export const MealPlanDescription = styled.p`
  ${props => props.theme.typography.body}
`;

export const ImageWrapper = styled.div`
  display: flex;
  max-height: 480px;
  max-width: 420px;
  border-radius: 32px;
  overflow: hidden;
  height: fit-content;
  img {
    width: 100%;
    height: auto;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(6)};
`;

export const PillTextWrapper = styled.div`
  position: static;

  @media ${props => props.theme.tablet} {
    position: absolute;
    top: 12px;
    right: 16px;
  }
`;

export const StyledGuaranteesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 325px;
  margin: auto;
  margin-top: ${props => props.theme.spacing(4)};
`;

export const StyledGuarantee = styled.div`
  p {
    margin-left: 0.5em;
  }
  display: flex;
  align-items: center;
`;

export const Testimonial = styled.div`
  background-color: ${props => props.theme.colors.background.lightest};
  padding: ${props => props.theme.spacing(6)};
  border-radius: 32px;
  margin-top: ${props => props.theme.spacing(8)};
`;

export const TestimonialDescription = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.spacing(1)};
`;

export const TestimonialImage = styled.div`
  max-height: 80px;
  max-width: 80px;
  overflow: hidden;
  border-radius: 80px;
`;

export const PupInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: ${props => props.theme.spacing(1)};
  padding-left: ${props => props.theme.spacing(2)};
`;

export const PupName = styled.h5`
  ${props => props.theme.typography.heading5}
`;

export const PupDesc = styled.div`
  display: flex;
  color: ${props => props.theme.colors.text.tertiary};
`;

export const TestimonialComment = styled.p`
  text-align: left;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;
